import { React, useRef, useState, useContext, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { red } from "@mui/material/colors";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import CardContent from "@mui/material/CardContent";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Dialog from "@mui/material/Dialog";
import swal from "sweetalert";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import axios from "axios";
import AuthContext from "../context/userAuth.context";
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import DialogContent from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function LinkGenerator(props) {
  const ImageUploderRef = useRef(null);
  const ImageUploderRef2 = useRef(null);
  const [logo, setLogo] = useState(null);
  const [videoURL, setVideoURL] = useState(null);
  const [contactUs, setContactUs] = useState(null);
  const [isGeneratingLink, setisGeneratingLink] = useState(false);
  const [showContactLink, setshowContactLink] = useState(true);
  const [showCTAbutton, setshowCTAbutton] = useState(false);
  const [showOptinForm, setshowOptinForm] = useState(false);
  const [showOwnerDetails, setshowOwnerDetails] = useState(false);
  const [userImg, setuserImg] = useState(null);
  const [previewuserImg, setpreviewuserImg] = useState("");
  const [contactText, setContactText] = useState(null);
  const [contactURL, setContactURL] = useState(null);
  const [CTAButtonText, setCTAButtonText] = useState(null);
  const [userHeadline, setuserHeadline] = useState(null);
  const [userDesc, setuserDesc] = useState(null);
  const [CTAButtonURL, setCTAButtonURL] = useState(null);
  const [optinCode, setOptinCode] = useState(null);
  const [videoTime, setVideoTime] = useState(null);
  const [buttonTime, setButtonTime] = useState(null);
  const [allUserPages, setAllUserPages] = useState([]);
  const [previewLogo, setpreviewLogo] = useState(
    "https://app.toons.ai/images/Logo.png"
  );
  const [showLogoError, setshowLogoError] = useState(false);
  const [showUserImgError, setshowUserImgError] = useState(false);
  const [showVideoUrlError, setshowVideoUrlError] = useState(false);
  const [showContactLinkError, setshowContactLinkError] = useState(false);
  const [showCTAButtonError, setshowCTAButtonError] = useState(false);
  const [showOptinFormError, setshowOptinFormError] = useState(false);
  useEffect(() => {
    getALlUserPages();
  }, []);

  const getALlUserPages = () => {
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Export/getAllUserGeneratedPages",
        null,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((res) => {
        setAllUserPages(res.data.data);
      });
  };

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );
  const { authenticationData, Role } = useContext(AuthContext);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    height: 600,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const closeLinkGenPop = () => {
    props.setLinkGenPop(false);
  };

  const imageUpload = () => {
    ImageUploderRef.current.click();
  };

  const imageUpload2 = () => {
    ImageUploderRef2.current.click();
  };

  const onSelectFile = async (e) => {
    const objectUrl = URL.createObjectURL(e.target.files[0]);
    const imgBlob = await fetch(objectUrl).then((r) => r.blob());
    var reader = new FileReader();
    reader.readAsDataURL(imgBlob);
    reader.onloadend = function () {
      var base64data = reader.result;
      setLogo(base64data);
      setpreviewLogo(base64data);
    };
  };

  const onSelectFile2 = async (e) => {
    const objectUrl = URL.createObjectURL(e.target.files[0]);
    const imgBlob = await fetch(objectUrl).then((r) => r.blob());
    var reader = new FileReader();
    reader.readAsDataURL(imgBlob);
    reader.onloadend = function () {
      var base64data = reader.result;
      setuserImg(base64data);
      setpreviewuserImg(base64data);
    };
  };

  const GeneratePageLink = () => {
    var validation = true;

    if (!videoURL) {
      setshowVideoUrlError(true);
      validation = false;
    }
    if (!logo) {
      setshowLogoError(true);
      validation = false;
    }
    if ((!contactURL || !contactUs) && showContactLink) {
      setshowContactLinkError(true);
      validation = false;
    }
    if ((!CTAButtonText || !CTAButtonURL) && showCTAbutton) {
      setshowCTAButtonError(true);
      validation = false;
    }
    if ((!optinCode || !videoTime) && showOptinForm) {
      setshowOptinFormError(true);
      validation = false;
    }
    if ((!userImg || !userHeadline || !userDesc) && showOwnerDetails) {
      setshowUserImgError(true);
      validation = false;
    }

    if (validation) {
      let formdata = new FormData();

      formdata.append("logo", logo);
      formdata.append("videoURL", videoURL);
      if (showContactLink) {
        formdata.append("contactText", contactUs);
        formdata.append("contactURL", contactURL);
      }

      if (showCTAbutton) {
        formdata.append("CTAButtonText", CTAButtonText);
        formdata.append("CTAButtonURL", CTAButtonURL);
      }

      if (showOptinForm) {
        formdata.append("optinCode", optinCode);
        formdata.append("videoTime", videoTime);
      }

      if (showOwnerDetails) {
        formdata.append("userImg", userImg);
        formdata.append("userHeadline", userHeadline);
        formdata.append("userDesc", userDesc);
      }

      axios
        .post(
          authenticationData.ApiBaseURL + "/api/Export/GenerateUserPageLink",
          formdata,
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((res) => {
          if (res.data.status == true) {
            swal(
              "Excellent",
              "Your shareable page link has been generated.",
              "success"
            );
            getALlUserPages();
            setVideoURL(null);
            setContactUs(null);
            setisGeneratingLink(false);
            setshowContactLink(true);
            setshowCTAbutton(false);
            setshowOwnerDetails(false);
            setpreviewuserImg("");
            setuserImg(null);
            setuserHeadline(null);
            setuserDesc(null);
            setshowOptinForm(false);
            setContactText(null);
            setContactURL(null);
            setCTAButtonText(null);
            setCTAButtonURL(null);
            setOptinCode(null);
            setVideoTime(null);
            setshowLogoError(false);
            setshowVideoUrlError(false);
            setshowContactLinkError(false);
            setshowCTAButtonError(false);
            setshowOptinFormError(false);
            setshowUserImgError(false);
            setpreviewLogo(null);
            setLogo(null);
            getALlUserPages();
          }
        });
    }
  };

  const deletPageLink = (id) => {
    let formdata = new FormData();
    formdata.append("id", id);
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Export/deletUserPageLink",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((res) => {
        if (res.data.status == true) {
          getALlUserPages();
          alert("Deleted Successfully....");
        }
      });
  };

  return (
    <Dialog
      open={props.linkGenPop}
      closeAfterTransition
      maxWidth="lg"
      fullWidth={true}
    >
      <DialogTitle
        id="alert-dialog-title mr-4"
        style={{ marginRight: "100px" }}
      >
        {!isGeneratingLink ? (
          <>Your shareable links </>
        ) : (
          <> Generate new link </>
        )}

        <IconButton
          onClick={closeLinkGenPop}
          style={{ position: "absolute", right: "10px", top: "10px" }}
          aria-label="Close"
        >
          <CloseIcon />
        </IconButton>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {isGeneratingLink ? (
              <Button
                onClick={(e) => {
                  getALlUserPages();
                  setisGeneratingLink(false);
                }}
                startIcon={<ArrowBackIcon />}
                sx={{
                  mt: 2,

                  textTransform: "none",
                }}
                variant="text"
                disableElevation
              >
                Back
              </Button>
            ) : (
              <Button
                onClick={() => setisGeneratingLink(true)}
                startIcon={<AddIcon />}
                align="right"
                sx={{
                  mt: 2,

                  textTransform: "none",
                }}
                variant="contained"
                disableElevation
              >
                Generate new link
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogTitle>

      {!isGeneratingLink ? (
        <DialogContent>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Id</strong>
                  </TableCell>
                  <TableCell>
                    <strong>URL</strong>
                  </TableCell>
                  <TableCell align="right">
                    <strong>Actions</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allUserPages.map((item, i) => {
                  return (
                    <TableRow>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.pageLink}</TableCell>
                      <TableCell align="right">
                        <Stack
                          justifyContent="flex-end"
                          direction="row"
                          spacing={2}
                        >
                          <Tooltip title="Delete">
                            <IconButton
                              onClick={(e) => {
                                deletPageLink(item.id);
                              }}
                            >
                              <DeleteIcon sx={{ color: red[500] }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Copy URL">
                            <IconButton
                              onClick={() => {
                                navigator.clipboard.writeText(item.pageLink);
                              }}
                            >
                              <ContentCopyIcon />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      ) : (
        // this is the case where we are generating new link
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12}>
              <TextField
                size="small"
                onChange={(e) => {
                  setVideoURL(e.target.value);
                }}
                value={videoURL}
                id="outlined-basic"
                style={{ width: "100%" }}
                label="Enter YouTube/Vimeo Video URL"
                variant="outlined"
              />
              {!videoURL && showVideoUrlError && (
                <Stack>
                  <label
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      fontWeight: "bolder",
                      color: "red",
                      marginTop: "3px",
                    }}
                    className="errorMsg"
                  >
                    Please enter a video url
                  </label>
                </Stack>
              )}

              <Button
                color="secondary"
                onClick={(e) => {
                  imageUpload();
                }}
                startIcon={<FileUploadIcon />}
                align="right"
                sx={{
                  mt: 2,

                  textTransform: "none",
                }}
                variant="contained"
                disableElevation
              >
                Upload Logo
              </Button>
              <input
                ref={ImageUploderRef}
                hidden
                type="file"
                accept="image/png, image/jpeg"
                onChange={onSelectFile}
              ></input>

              {logo && (
                <>
                  <img
                    style={{
                      height: "30px",
                      marginLeft: "12px",
                      marginRight: "0px",
                      marginTop: "20px",
                    }}
                    src={previewLogo}
                  ></img>
                </>
              )}
              {!logo && showUserImgError && (
                <Stack>
                  <label
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      fontWeight: "bolder",
                      color: "red",
                      marginTop: "3px",
                    }}
                    className="errorMsg"
                  >
                    Please upload your image
                  </label>
                </Stack>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                mt: 1,
              }}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                {/* <AddIcon fontSize="small" /> */}
                <label
                  style={{
                    fontSize: "12px",
                    textTransform: "uppercase",
                    fontWeight: "bolder",
                  }}
                >
                  Add interactive elements to the page.
                </label>
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                mt: 0,
              }}
            >
              <Stack direction="row" alignItems="center" spacing={5}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      onClick={(e) => setshowContactLink(e.target.checked)}
                      checked={showContactLink}
                    />
                  }
                  label="Contact link"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      onClick={(e) => setshowCTAbutton(e.target.checked)}
                      checked={showCTAbutton}
                    />
                  }
                  label="CTA button"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      onClick={(e) => setshowOptinForm(e.target.checked)}
                      checked={showOptinForm}
                    />
                  }
                  label="Optin Form"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      onClick={(e) => setshowOwnerDetails(e.target.checked)}
                      checked={showOwnerDetails}
                    />
                  }
                  label="Owner Details"
                />
              </Stack>

              {showContactLink && (
                <Stack spacing={2} sx={{ mt: 2 }}>
                  <label style={{ fontSize: "10px", fontWeight: "bolder" }}>
                    Contact link details:
                  </label>
                  {(!contactUs || !contactURL) && showContactLinkError && (
                    <Stack>
                      <label
                        style={{
                          fontSize: "12px",
                          textTransform: "uppercase",
                          fontWeight: "bolder",
                          color: "red",
                          marginTop: "3px",
                        }}
                        className="errorMsg"
                      >
                        Please enter contact text and contact url. Deselect
                        Conact link if you don't to add this.
                      </label>
                    </Stack>
                  )}

                  <Stack direction="row" alignItems="center" spacing={1}>
                    <TextField
                      onChange={(e) => setContactUs(e.target.value)}
                      size="small"
                      value={contactUs}
                      id="outlined-basic"
                      style={{ width: "200px" }}
                      label="Contact text"
                      variant="outlined"
                    />

                    <TextField
                      value={contactURL}
                      onChange={(e) => {
                        setContactURL(e.target.value);
                      }}
                      size="small"
                      id="outlined-basic"
                      style={{ width: "400px" }}
                      label="Contact URL"
                      variant="outlined"
                    />
                  </Stack>
                </Stack>
              )}
              {showCTAbutton && (
                <Stack spacing={2} sx={{ mt: 3 }}>
                  <label style={{ fontSize: "10px", fontWeight: "bolder" }}>
                    CTA button details:
                  </label>
                  {(!CTAButtonText || !CTAButtonURL) && showCTAButtonError && (
                    <Stack>
                      <label
                        style={{
                          fontSize: "12px",
                          textTransform: "uppercase",
                          fontWeight: "bolder",
                          color: "red",
                          marginTop: "3px",
                        }}
                        className="errorMsg"
                      >
                        Please enter CTA button text and CTA button url.
                        Deselect CTA Button if you don't to add this.
                      </label>
                    </Stack>
                  )}

                  <Stack direction="row" alignItems="center" spacing={1}>
                    <TextField
                      value={CTAButtonText}
                      onChange={(e) => {
                        setCTAButtonText(e.target.value);
                      }}
                      size="small"
                      id="outlined-basic"
                      style={{ width: "200px" }}
                      label="Button text"
                      variant="outlined"
                    />
                    <TextField
                      value={CTAButtonURL}
                      onChange={(e) => {
                        setCTAButtonURL(e.target.value);
                      }}
                      size="small"
                      id="outlined-basic"
                      style={{ width: "400px" }}
                      label="Button URL"
                      variant="outlined"
                    />
                    {/* <TextField
                      value={videoTime}
                      onChange={(e) => {
                        setButtonTime(e.target.value);
                      }}
                      size="small"
                      label="Button Time(Seconds)"
                      rows={4}
                      defaultValue=" "
                      variant="outlined"
                    /> */}
                  </Stack>
                </Stack>
              )}
              {showOptinForm && (
                <Stack spacing={2} sx={{ mt: 3 }}>
                  <label style={{ fontSize: "10px", fontWeight: "bolder" }}>
                    Optin form embed code:
                  </label>
                  {(!optinCode || videoTime) && showOptinFormError && (
                    <Stack>
                      <label
                        style={{
                          fontSize: "12px",
                          textTransform: "uppercase",
                          fontWeight: "bolder",
                          color: "red",
                          marginTop: "3px",
                        }}
                        className="errorMsg"
                      >
                        Please enter code below and select video time in seconds
                        at which optin form will show. Deselect Optin Form if
                        you don't to add this.
                      </label>
                    </Stack>
                  )}

                  <Stack direction="row" alignItems="center" spacing={1}>
                    <TextField
                      value={optinCode}
                      onChange={(e) => {
                        setOptinCode(e.target.value);
                      }}
                      size="small"
                      label="Paste code here"
                      multiline
                      rows={4}
                      defaultValue=" "
                      variant="outlined"
                    />

                    <TextField
                      value={videoTime}
                      onChange={(e) => {
                        setVideoTime(e.target.value);
                      }}
                      size="small"
                      label="Video Time(Seconds)"
                      rows={4}
                      defaultValue=" "
                      variant="outlined"
                    />
                  </Stack>
                </Stack>
              )}
              {showOwnerDetails && (
                <Stack spacing={2} sx={{ mt: 3 }}>
                  <label style={{ fontSize: "10px", fontWeight: "bolder" }}>
                    Owner Details:
                  </label>

                  {(!userImg || !userDesc || !userHeadline) &&
                    showUserImgError && (
                      <Stack>
                        <label
                          style={{
                            fontSize: "12px",
                            textTransform: "uppercase",
                            fontWeight: "bolder",
                            color: "red",
                            marginTop: "3px",
                          }}
                          className="errorMsg"
                        >
                          Please add Image, Headline and Description to proceed.
                        </label>
                      </Stack>
                    )}

                  <Stack direction="row">
                    <Button
                      style={{ width: "200px" }}
                      color="secondary"
                      onClick={(e) => {
                        imageUpload2();
                      }}
                      startIcon={<FileUploadIcon />}
                      align="right"
                      sx={{
                        mt: 2,

                        textTransform: "none",
                      }}
                      variant="contained"
                      disableElevation
                    >
                      Upload your image
                    </Button>
                    <input
                      ref={ImageUploderRef2}
                      hidden
                      type="file"
                      accept="image/png, image/jpeg"
                      onChange={onSelectFile2}
                    ></input>
                    {userImg && (
                      <>
                        <img
                          style={{
                            height: "30px",
                            marginLeft: "12px",
                            marginRight: "0px",
                            marginTop: "20px",
                          }}
                          src={previewuserImg}
                        ></img>
                      </>
                    )}
                  </Stack>
                  <Stack spacing={2}>
                    <TextField
                      value={userHeadline}
                      onChange={(e) => {
                        setuserHeadline(e.target.value);
                      }}
                      size="small"
                      id="outlined-basic"
                      style={{ width: "500px" }}
                      label="Headline"
                      variant="outlined"
                    />
                    <TextField
                      value={userDesc}
                      onChange={(e) => {
                        setuserDesc(e.target.value);
                      }}
                      size="small"
                      label="Description"
                      multiline
                      rows={4}
                      defaultValue=""
                      variant="outlined"
                    />
                  </Stack>
                </Stack>
              )}

              <Button
                startIcon={<AddIcon />}
                align="right"
                onClick={GeneratePageLink}
                sx={{
                  mt: 3,
                  mb: 3,
                  textTransform: "none",
                }}
                variant="contained"
                disableElevation
              >
                Create link
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      )}

      {/* <Box sx={style}>
        <Button
          size="small"
          color="error"
          onClick={closeLinkGenPop}
          style={{ float: "right", marginRight: 5 }}
        >
          <CloseIcon />
        </Button>
        <Paper
          style={{
            height: 500,
            borderRadius: 5,
            backgroundColor: "transparent",
          }}
        >
          <h1>Share Page</h1>
          <h5>Allow you to share your video page link with your clients</h5>

          <hr />
          <Grid container spacing={2}>
            <Grid item xs={2} md={12}>
              <TextField
                onChange={(e) => {
                  setVideoURL(e.target.value);
                }}
                value={videoURL}
                id="outlined-basic"
                style={{ width: "300px" }}
                label="Enter YouTube/Vimeo Video URL"
                variant="outlined"
              />
              <TextField
                onChange={(e) => {
                  setContactUs(e.target.value);
                }}
                value={contactUs}
                id="outlined-basic"
                style={{ width: "300px" }}
                label="Enter Email ID to Contact"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={2} md={12}>
              <div className="watermarkpanel NotAdded">
                <div className="">
                  <div
                    onClick={(e) => {
                      imageUpload();
                    }}
                    className="image_uploader_inner"
                    style={{ marginBottom: "10px" }}
                  >
                    <div className="Image_uploader_text">
                      <div className="flex">
                        <span className="material-icons customBtnIcon">
                          upload
                        </span>
                        Upload Logo
                      </div>

                      <input
                        ref={ImageUploderRef}
                        hidden
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={onSelectFile}
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid item xs={2} md={12}>
              <Button onClick={GeneratePageLink} variant="contained">
                Generate Page Link
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Box> */}
    </Dialog>
  );
}

export default LinkGenerator;
